import React from 'react';
import { Icon } from '@benzinga/core-ui';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import customStyles from '../customStyles';
import styled from '@benzinga/themetron';

export interface VersusCardProps {
  coins: string[];
  content: string;
  title: string;
  url: string;
}

const VSBlock = styled.div`
  & > span {
    line-height: 4rem;
  }
  @media (min-width: 768px) {
    min-width: 8rem;
    width: 8rem;

    & > span {
      line-height: 2em;
    }
  }
`;

export const VersusCard = ({ coins, content, title, url }: VersusCardProps) => (
  <div className="md:flex-row bg-white flex flex-col p-4 rounded" style={{ boxShadow: customStyles.boxShadow }}>
    <VSBlock className="bg-white border border-gray-400 border-opacity-50 md:mb-0 mb-4 md:h-36 md:px-0 md:flex-col md:justify-center flex font-semibold h-16 items-center justify-between mb-2 mr-3 px-4 rounded text-gray-800 uppercase w-full">
      {coins[0]}
      <span
        className="md:max-w-full md:my-3 md:leading-none md:h-8 h-full leading-7 max-w-24 text-base text-center text-gray-600 w-full"
        style={{
          background:
            'linear-gradient(266.25deg, rgba(255, 255, 255, 0) 1.19%, #E1EBFA 51.09%, rgba(255, 255, 255, 0) 100%)',
        }}
      >
        VS
      </span>
      {coins[1]}
    </VSBlock>
    <div className="flex flex-col items-start justify-center">
      <h2 className="uppercase font-semibold text-gray-800 mb-1.5">{title}</h2>
      <p className="text-gray-600 mb-4 md:mb-2">{content}</p>
      <a
        className="uppercase text-blue-500 font-semibold bg-blue-400 bg-opacity-10 rounded py-1 px-4 flex items-center w-full justify-between md:w-auto"
        href={url}
        rel="noopener noreferrer"
        target="_blank"
      >
        LEARN MORE
        <Icon className="text-gray-600 text-opacity-80 ml-2" icon={faArrowRight} />
      </a>
    </div>
  </div>
);
